import React from 'react'
import { initializeApollo } from 'gql/client'
import { PAGINA } from 'utils/queries'
import LandingTemplate from '@components/templates/LandingTemplate/LandingTemplate'
import RegistrazioneTemplate from '@components/templates/RegistrazioneTemplate/RegistrazioneTemplate'
import { NextWrapper } from 'data-fetching-wrapper'

//const NewsletterPage = ({ pagina }) => <LandingTemplate pagina={pagina} preferenzeOpen />
//TODO: ripristinato momentaneamente il vecchio template
const NewsletterPage = ({ pagina }) => <RegistrazioneTemplate pagina={pagina} preferenzeOpen />


export const getStaticProps = NextWrapper.getStaticProps(async () => {
  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: PAGINA,
    variables: { chiave: 'newsletter' },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }
  return {
    props: { pagina },
    revalidate: 60 * 2,
  }
}, '/newsletter')

export default NewsletterPage
